export default function Hero(props) {
	return (
		<div className="py-4 bg-gradient-to-br from-neutral-300 dark:from-neutral-700 to-neutral-100 dark:to-neutral-900 min-h-screen flex flex-col items-center justify-center">
      <div className="mx-8 md:mx-64 py-4 lg:py-8 px-4 lg:px-8 text-4xl md:text-5xl text-neutral-900 dark:text-neutral-100 border-2 border-neutral-900 dark:border-neutral-100 rounded-xl flex">
        A Certain Girl's Tale, Beautifully Crafted by Lewis Carroll
      </div>
      <button className="mt-4 bg-neutral-900 hover:bg-neutral-700 dark:bg-neutral-100 dark:hover:bg-neutral-300 active:ring-4 active:ring-neutral-500 rounded-lg px-4 py-2 text-xl text-neutral-100 dark:text-neutral-900" onClick={props.action}>
        Start Reading
      </button>
    </div>
	)
}